import * as placeholder from 'app/components/text/placeholderText'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  placeholder,
}
